import { z } from "zod";
import { appConfig } from '../config/app.config';
import { PostMessageEvent } from '../enums/post-message-event.enum';

export const postMessageSchema = z.object({
  access_key: z.string().refine(value => value == appConfig().post_message_access_key),
  event: z.nativeEnum(PostMessageEvent),
  data: z.optional(z.record(z.any()))
});